package org.vreo.devicehub.features.core.presentation

import devicehub.composeapp.generated.resources.Res

import org.vreo.devicehub.features.core.domain.device.videoCameraConfig.VideoFrameRotation
import devicehub.composeapp.generated.resources.frame_rotation_enum_name_0
import devicehub.composeapp.generated.resources.frame_rotation_enum_name_180
import devicehub.composeapp.generated.resources.frame_rotation_enum_name_90
import devicehub.composeapp.generated.resources.frame_rotation_enum_name_90_counter_clockwise

/**
 * Converts [VideoFrameRotation] to [UiText].
 */
fun VideoFrameRotation.toUiText(): UiText {
    val stringRes = when(this) {
        VideoFrameRotation.ROTATE_0 -> Res.string.frame_rotation_enum_name_0
        VideoFrameRotation.ROTATE_90 -> Res.string.frame_rotation_enum_name_90
        VideoFrameRotation.ROTATE_180 -> Res.string.frame_rotation_enum_name_180
        VideoFrameRotation.ROTATE_90_COUNTER_CLOCKWISE -> Res.string.frame_rotation_enum_name_90_counter_clockwise
    }

    return UiText.StringResourceId(stringRes)
}